module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec02_pc_73b9e95de488ce2d7d799c7d0780aa4f.jpg";